import { tss } from 'tss-react/mui';

export const useOutboundCallStatusStyles = tss.create(({ theme }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  statusSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    padding: '32px 24px',
    gap: '12px',
  },
  iconWrapper: {
    width: 72,
    height: 72,
    borderRadius: '50%',
    backgroundColor: '#eef2ff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '4px',
    position: 'relative' as const,
  },
  callIcon: {
    fontSize: 28,
    color: theme.palette.primary.main,
  },
  title: {
    fontSize: '20px',
    fontWeight: 600,
    color: '#1f2937',
  },
  phoneNumber: {
    fontSize: '15px',
    color: '#374151',
    fontWeight: 500,
    fontFamily: 'monospace',
    backgroundColor: '#f3f4f6',
    padding: '6px 16px',
    borderRadius: '20px',
  },
  statusRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginTop: '4px',
  },
  statusText: {
    fontSize: '14px',
    color: '#6b7280',
  },
  qualityIndicator: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '4px 10px',
    borderRadius: '16px',
    backgroundColor: '#f9fafb',
    border: '1px solid #e5e7eb',
    marginTop: '4px',
  },
  qualityLabel: {
    fontSize: '12px',
    fontWeight: 500,
  },
  conversationSection: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 300,
    maxHeight: 500,
    borderTop: '1px solid #e5e7eb',
  },
  conversationHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 20px',
    borderBottom: '1px solid #f3f4f6',
  },
  conversationHeaderLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  liveIndicator: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  liveDot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: '#22c55e',
    animation: '$pulse 2s ease-in-out infinite',
  },
  '@keyframes pulse': {
    '0%, 100%': { opacity: 1 },
    '50%': { opacity: 0.4 },
  },
  liveText: {
    fontSize: '13px',
    fontWeight: 600,
    color: '#22c55e',
  },
  headerPhoneNumber: {
    fontSize: '13px',
    color: '#6b7280',
    fontFamily: 'monospace',
  },
  buttonContainer: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'center',
    padding: '16px 24px',
    borderTop: '1px solid #e5e7eb',
  },
  primaryButton: {
    textTransform: 'none' as const,
    fontWeight: 600,
    borderRadius: '8px',
    padding: '8px 24px',
    fontSize: '14px',
    color: '#374151',
    borderColor: '#d1d5db',
    '&:hover': {
      borderColor: '#9ca3af',
      backgroundColor: '#f9fafb',
    },
  },
  closeButton: {
    textTransform: 'none' as const,
    fontWeight: 600,
    borderRadius: '8px',
    padding: '8px 24px',
    fontSize: '14px',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
  },
}));
